import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { RequestHandler } from '../app/RequestHandler';

import { Location } from '../components/Breadcrumb/interfaces';
import useTranslation from '../features/translation/hooks/useTranslation';
import { preparationSectionTranslationKey } from '../utils';

enum TranslationKeys {
  FESTO_HOME = 'home',
  ENGINEERING_TOOLS = 'engineeringTools',
  HOME_PAGE = 'shockAbsorberApplication',
  RESULTS_PAGE = 'resultsPage',
}

const getLocation = (label: string, url: string): Location => {
  return {
    label,
    url,
  };
};

const filterLocationsByRoute = (
  currentRoute: string | undefined,
  home: Location | null,
  applicationDetail: Location | null,
  result: Location | null,
): Location[] => {
  const locations = [home, applicationDetail, result];

  switch (currentRoute) {
    // default: //Este default está aquí para forzar que el return sea del tipo Location[]
    case '/': {
      // Home Page
      const [h] = locations;
      return h ? [h] : [];
    }
    // case 'entrypage_application_detail': {
    case 'results': {
      // Result Page
      const [h, ad, r] = locations;
      return h && ad && r ? [h, ad, r] : [];
    }
    default: {
      // Entry Page Detail
      const [h, ad] = locations;
      return h && ad ? [h, ad] : [];
    }
  }
};

const useCustomLocation = () => {
  const t = useTranslation();
  const loc = useLocation();
  const { country, language } = new RequestHandler();

  const { pathname } = loc;
  const [locations, setLocations] = useState<Location[]>([{ label: ``, url: '/' }]);

  useEffect(() => {
    let myBreadcrumbs: Location[] = [];
    const homeRoute = getLocation(t(TranslationKeys.HOME_PAGE), '/');
    const festoHomeUrl = `${process.env.REACT_APP_FESTO_URL}${country}/${language}/`;
    const engineeringToolsUrl = `${process.env.REACT_APP_FESTO_URL}${country}/${language}/e/products/digital-engineering-tools-id_650881/`;

    if (pathname === '/') {
      myBreadcrumbs = filterLocationsByRoute(pathname, homeRoute, null, null);
    } else if (pathname.endsWith('results')) {
      const urls = pathname.split('/').filter((p) => p !== '');

      const applicationDetailLabel = preparationSectionTranslationKey(urls[0]);
      const applicationDetailRoute = getLocation(t(applicationDetailLabel as string), urls[0]);
      const resultRoute = getLocation(t(TranslationKeys.RESULTS_PAGE), urls[1]);

      myBreadcrumbs = filterLocationsByRoute(urls[1], homeRoute, applicationDetailRoute, resultRoute);
    } else {
      const applicationDetailLabel = preparationSectionTranslationKey(pathname);
      const applicationDetailRoute = getLocation(t(applicationDetailLabel as string), pathname);

      myBreadcrumbs = filterLocationsByRoute(pathname, homeRoute, applicationDetailRoute, null);
    }

    const engineeringToolsLocation: Location = {
      label: t(TranslationKeys.ENGINEERING_TOOLS),
      url: engineeringToolsUrl,
    };
    const festoHomeLocation: Location = { label: t(TranslationKeys.FESTO_HOME), url: festoHomeUrl };

    myBreadcrumbs.unshift(engineeringToolsLocation);
    myBreadcrumbs.unshift(festoHomeLocation);

    setLocations(myBreadcrumbs);
  }, [country, language, pathname, t]);

  return {
    pathname,
    locations,
  };
};

export default useCustomLocation;
